export const services = [
  {
    id: "project-management",
    title: "Project Management",
    icon: "/uploads/home/our_services_01.svg",
    description:
      "With our experience and proven methodology, our professional team help customer drive project to success from Kick-off to launch day.\n\nWe constantly estimate and evaluate to ensure that project execute within scope and make aware of risks and uncertainties.",
    revealDelay: "100",
  },
  {
    id: "data-analytic-solution",
    title: "Data Analytic Solution",
    icon: "/uploads/home/our_services_02.svg",
    description:
      "In today business, data is the crucial factor to win the market, both to improve operation for cost saving and better ROI or gain insight\n\nOur data specialist helps analyze, not just your data but also the process of acquiring and using the data. Build, design and improve the whole data platform for you with latest analytic technology.",
    revealDelay: "200",
  },
  {
    id: "customize-software-platform",
    title: "Customize Software & Platform",
    icon: "/uploads/home/our_services_03.svg",
    description:
      "Your desires to launch web and mobile application make simple. With our expertise in app development, we look into your needs and constraints then propose solution that meet those criterias.\n\nFrom analyze, design, implementation and monitor for improvement, we work with you through feedback loop so that you gain utmost satisfaction with our deliverables.",
    revealDelay: "100",
  },
  {
    id: "cloud-solutions",
    title: "Cloud Solutions",
    icon: "/uploads/home/our_services_04.svg",
    description:
      "Digital transformation can help improve business process and gain business value significantly.\n\nWith our deep understanding of cloud technology and cloud economic, we analyze your business process and/or existing IT infrastructure and make suggestion for possibility of leveraging cloud technology or migration for cost saving, ROI, innovations.",
    revealDelay: "200",
  },
];

export const awsPartnership = {
  sectionTitle: "AWS Partner Advanced Tier Services",
  badgeImage: "/uploads/home/awsxts.svg",
  logoImage: "/uploads/home/aws.svg",
  heading:
    "TradeSquare: An AWS Partner Advanced Tier Firm Driving Full-Spectrum Cloud Transformation",
  paragraphs: [
    "TradeSquare has proudly attained the coveted AWS Partner Advanced Tier status, cementing our role as a leader in the cloud-native landscape. This milestone reflects more than just technical excellence; it underscores our holistic vision for leveraging AWS to drive comprehensive business transformation—from foundational migration and application modernization to pioneering data and AI innovation.",
    "In today's dynamic economy, the cloud is the essential platform for agility, scale, and competitive advantage. Our proven ability to architect, build, and manage sophisticated AWS environments covers the complete cloud lifecycle. Our deep collaboration with AWS ensures we apply best practices across their entire suite of services, translating powerful cloud capabilities into tangible business outcomes.",
  ],
  partnerItemsHeading: "We partner with organizations to:",
  partnerItems: [
    {
      title: "Modernize and Migrate with Confidence",
      detail:
        "Seamlessly transition legacy workloads to the cloud, reducing technical debt and establishing a secure, scalable, and cost-optimized foundation for the future.",
    },
    {
      title: "Build Cloud-Native Excellence",
      detail:
        "Accelerate your development cycles by building and deploying resilient, scalable applications using modern practices like serverless, containers, and DevOps automation.",
    },
    {
      title: "Innovate with Data and AI",
      detail:
        "Transform your data into a strategic asset and automate complex processes with custom machine learning models and intelligent, AI-powered applications.",
    },
  ],
  closingNote:
    "With TradeSquare, you gain a partner dedicated to every stage of your cloud journey, ensuring you not only unlock the full potential of your infrastructure but also harness it to redefine what's possible for your business.",
};
